<script lang="ts" setup>
import OmniDialog from "@/components/OmniDialog.vue";
import { API } from "@/api/api";
import { useSnackbarStore } from "@/store/snackbar.store";

const api = new API();
const { showSnackbarError, showSnackbarSuccess } = useSnackbarStore();

const model = defineModel<boolean>({ default: false });

const props = defineProps<{
  routeId: number;
  checkCallId: number;
}>();

const emits = defineEmits<{
  (e: "update"): void;
  (e: "update:modelValue", value: boolean): void;
}>();

async function dismiss() {
  try {
    const response = await api.events.dismissCheckCall(props.routeId, props.checkCallId);

    if (!response.success) {
      const message = response?.data?.detail || "Could not dismiss call call";
      showSnackbarError(message);

      return;
    }

    showSnackbarSuccess("Dismissed check call successfully");
    emits("update");
    emits("update:modelValue", false);
  } catch (error) {
    showSnackbarError("Could not dismiss call call");
  }
}
</script>

<template>
  <omni-dialog
    v-model="model"
    primary-action-label="Dismiss"
    title="Dismiss check call"
    @primary-action:click="dismiss"
  >
    <span class="text-grey-darken-1">Are you sure you want to dismiss this check call?</span>
  </omni-dialog>
</template>

<style lang="scss" scoped></style>
